// extracted by mini-css-extract-plugin
module.exports = {"pane":"FieldsPane_pane__w8ugS","col":"FieldsPane_col__E7UQr"};